import { isMobile } from "../utilities";

window.addEventListener("FormClientRendered", () => {
    const isTilesChatTheme = document.querySelector(".tiles-theme");
    const isBrandTheme = document.querySelector(".brand-theme");

    if (!isTilesChatTheme && !isBrandTheme) return;

    if (isBrandTheme) {
        const Steps = document.querySelectorAll(".Step");
        const trustIcons = document.querySelector(".footer-fpq__trust");
        if (!trustIcons) return;

        Steps.forEach((step) => {
            var questionContainer = step.querySelector(".Question .Container");
            var formContainer = step.querySelector(".Form");
            var trustBannerClone = trustIcons.cloneNode(true);
            questionContainer && questionContainer.appendChild(trustBannerClone);
            formContainer && formContainer.appendChild(trustBannerClone);

            const smsFormEl = step.querySelectorAll(".sms_optin_text");
            smsFormEl &&
                smsFormEl.forEach(function (sms) {
                    const smsFormElClone = sms.cloneNode(true);
                    questionContainer && questionContainer.appendChild(smsFormElClone);
                });
        });
    }

    const qualifyElements = document.querySelectorAll("#qualifyTextElement");
    const hasQualifyElements = qualifyElements.length > 0;

    if (hasQualifyElements) {
        qualifyElements.forEach((el) => {
            const stepContainer = el.closest(".Container");
            const newQualifyEl = el.cloneNode(true);
            stepContainer.insertBefore(newQualifyEl, stepContainer.firstChild);
        });
    }

    const introText = document.querySelector(".QuestionnaireHeader .TextLabel");

    if (isMobile()) return;

    const introTextDesktop = introText.cloneNode(true);
    const ageGroupStep = document.querySelector(".Step.cc__age-group");
    const stepHeader = ageGroupStep && ageGroupStep.querySelector(".StepHeader");
    ageGroupStep && stepHeader.appendChild(introTextDesktop);
});
